import AICoachProfile from './AICoachProfile';

export default AICoachProfile;
